module.exports = __webpack_public_path__ + "img/animals_01_H.6d733e64.webp";